import React from 'react';

import { TestCyclesOverviewForm } from '@qality/common-components/src/organisms/TestCyclesOverviewForm';

interface TestCyclesOverviewPageViewProps {
  initialProject?: { name: string; id: string; key: string };
}

export const TestCyclesOverviewPageView: React.FC<TestCyclesOverviewPageViewProps> =
  ({ initialProject }: TestCyclesOverviewPageViewProps) => {
    const initialValues = {
      ...(initialProject
        ? {
            project: {
              label: `${initialProject.name} (${initialProject.key})`,
              value: initialProject.key,
              id: initialProject.id,
              key: initialProject.key,
            },
          }
        : null),
      state: {
        label: 'All states',
        value: null,
      },
      // this is just to trigger an update when necessary
      refreshCount: 0,
      pagination: {
        size: 10,
        page: 1,
      },
    };
    return <TestCyclesOverviewForm initialValues={initialValues} />;
  };
